import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const items = [
  {
    kicker: '01',
    title: 'Sito su misura',
    body: 'Sito vetrina, prenotazioni o e-commerce. Design pulito, pensato per il telefono, visibile su Google, modulo di contatto e WhatsApp. Online in 7–14 giorni.',
  },
  {
    kicker: '02',
    title: 'Gestione mensile',
    body: 'Modifiche, nuovi testi, backup, aggiornamenti, controllo velocità e piccola pubblicità. Un referente, zero stress.',
  },
  {
    kicker: '03',
    title: 'Risultati misurabili',
    body: 'Scheda Google, tracciamento visite, report semplice ogni mese. Il sito non resta fermo: lavora.',
  },
];

const CosaOttieni = () => {
  const handleContact = (e) => {
    e.preventDefault();
    const el = document.querySelector('#contatti');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="cosa-ottieni" className="cad-section">
      <p className="cad-kicker">02 · IL SITO</p>
      <h2>Il primo passo, per molti, è il sito.</h2>
      <p>
        Lo progettiamo e lo teniamo vivo. Se poi servono marketing, AI, legale o gare, resti nello stesso ecosistema.
      </p>

      <div className="cad-cards cad-cards-3">
        {items.map((item, index) => (
          <motion.article
            key={item.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: index * 0.08 }}
          >
            <span>{item.kicker}</span>
            <h3>{item.title}</h3>
            <p>{item.body}</p>
          </motion.article>
        ))}
      </div>

      <p>
        Preventivo in 24 ore. Nessun abbonamento nascosto. Il codice e il dominio restano tuoi.
      </p>

      <div className="cad-section-cta">
        <a href="#contatti" className="btn btn-primary" onClick={handleContact}>
          Parla con Tre Lune
        </a>
      </div>
      <Link to="/siti" className="cad-section-more">
        Sito e gestionale →
      </Link>
    </section>
  );
};

export default CosaOttieni;
